import { flow, types } from 'mobx-state-tree'
import { emsOnboardIntitutes } from '../../network/bulkEMSOnboardInstitutes'
import { emsOnboardStores } from '../../network/bulkEMSOnboardStores'
import { onboardIntitutes } from '../../network/bulkOnboardInstitutes'
import { onboardStores } from '../../network/bulkOnboardStores'
import { delink } from '../../network/delink'
import { delinkEMS } from '../../network/delinkEMS'
import { linkDevice } from '../../network/linkDevice'
import { linkEMSDevice } from '../../network/linkEMSDevice'
import { searchDeviceMappings } from '../../network/searchDeviceMappings'
import { searchEMSDeviceMappings } from '../../network/searchEMSDeviceMappings'
import { updateDeviceStatusApi } from '../../network/updateDeviceStatusApi'
import { MessageTypes, getErrorMessage } from '../../utils'
import { RootStore } from '../store'
const Device = types.model('Device', {
  id: types.optional(types.string, ''),
  sMid: types.optional(types.string, ''),
  mid: types.optional(types.string, ''),
  tid: types.optional(types.string, ''),
  dsn: types.optional(types.string, ''),
  linkedDeviceId: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  createdDate: types.optional(types.string, ''),
  link: types.optional(types.string, ''),
  deviceType: types.optional(types.string, ''),
})
export const Devices = types
  .model('Devices', {
    devicesList: types.array(Device),
    lastRequest: types.optional(types.string, '{}'),
    emsDevicesList: types.array(Device),
    lastEMSRequest: types.optional(types.string, '{}'),
  })
  .actions((self) => ({
    searchDevices: flow(function* searchDevices(data: any) {
      try {
        const response = yield searchDeviceMappings(data, RootStore.session.getTokens)
        let own = self
        own.lastRequest = JSON.stringify(data)
        own.devicesList = response ?? []
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    searchEMSDevices: flow(function* searchDevices(data: any) {
      try {
        const response = yield searchEMSDeviceMappings(data, RootStore.session.getTokens)
        let own = self
        own.lastEMSRequest = JSON.stringify(data)
        own.emsDevicesList = response ?? []
        return response
      } catch (error) {
        self.emsDevicesList = []
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    delinkDevice: flow(function* delinkDevice(deviceId: string, mid: string, deviceType: any) {
      try {
        const own: any = self
        const response = yield delink(deviceId, mid, deviceType, RootStore.session.getTokens)
        console.log(response)
        return own.searchDevices(JSON.parse(self.lastRequest))
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    updateDeviceStatusAsync: flow(function* updateDeviceStatusAsync(data: any, stateToUpdate: any) {
      try {
        //const response = yield delink( mid, deviceType, RootStore.session.getTokens)

        if (stateToUpdate === 'DELINKED') {
          yield (self as any).delinkDevice(data?.dsn, data?.mid, data?.deviceType)
        } else if (['ACTIVE', 'INACTIVE'].includes(stateToUpdate)) {
          yield updateDeviceStatusApi(
            {
              mid: data?.mid,
              deviceId: data?.dsn,
              status: stateToUpdate,
            },
            RootStore.session.getTokens,
          )
        }
        yield (self as any).searchDevices(JSON.parse(self.lastRequest))
        RootStore.message.setMessage('Device status updated successfully.', MessageTypes.SUCCESS)
        /// return own.searchDevices(JSON.parse(self.lastRequest))
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    delinkEMSDevice: flow(function* delinkEMSDevice(deviceId: string, mid: string, deviceType: any) {
      try {
        const own: any = self
        const response = yield delinkEMS(deviceId, RootStore.session.getTokens)
        console.log(response)
        return own.searchEMSDevices(JSON.parse(self.lastEMSRequest))
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    bulkLinkDevice: flow(function* (merchantData) {
      const errorData = []
      for (let i = 0; i < merchantData.length; i++) {
        try {
          if (merchantData[i].mid !== '' && merchantData[i].deviceId !== '') {
            const response = yield linkDevice(merchantData[i], RootStore.session.getTokens)
            if (response.error) {
              errorData.push({
                status: 'Failed',
                message: response?.error?.message ?? 'Failed',
                code: response?.error?.code ?? '',
              })
            } else {
              errorData.push({ status: 'SUCCESS', message: '', code: '' })
            }
          } else {
            errorData.push({ status: 'Failed', message: 'Invalid Data', code: 'Invalid Data' })
          }
        } catch (e) {
          errorData.push({
            status: 'Failure',
            message: getErrorMessage(e),
            code: (e as any)?.code ?? '',
          })
        }
        yield new Promise((r) => setTimeout(r, 100))
      }
      return errorData
    }),
    bulkEMSLinkDevice: flow(function* (merchantData) {
      const errorData = []
      for (let i = 0; i < merchantData.length; i++) {
        try {
          if (merchantData[i].mid !== '' && merchantData[i].deviceId !== '') {
            const response = yield linkEMSDevice(merchantData[i], RootStore.session.getTokens)
            if (response.error) {
              errorData.push({
                status: 'Failed',
                message: response?.error?.message ?? 'Failed',
                code: response?.error?.code ?? '',
              })
            } else {
              errorData.push({ status: 'SUCCESS', message: '', code: '' })
            }
          } else {
            errorData.push({ status: 'Failed', message: 'Invalid Data', code: 'Invalid Data' })
          }
        } catch (e) {
          errorData.push({
            status: 'Failure',
            message: getErrorMessage(e),
            code: (e as any)?.code ?? '',
          })
        }
        yield new Promise((r) => setTimeout(r, 100))
      }
      return errorData
    }),
    bulkStoresOnboard: flow(function* (storesData) {
      const errorData = []
      for (let i = 0; i < storesData.length; i++) {
        try {
          if (storesData[i].storeCode !== '' && storesData[i].institutionId !== '') {
            const response = yield onboardStores(storesData[i], RootStore.session.getTokens)
            if (response.error) {
              errorData.push({
                status: 'Failed',
                message: response?.error?.message ?? 'Failed',
                code: response?.error?.code ?? '',
              })
            } else {
              errorData.push({ status: 'SUCCESS', message: '', code: '' })
            }
          } else {
            errorData.push({ status: 'Failed', message: 'Invalid Data', code: 'Invalid Data' })
          }
        } catch (e) {
          errorData.push({
            status: 'Failure',
            message: getErrorMessage(e),
            code: (e as any)?.code ?? '',
          })
        }
        yield new Promise((r) => setTimeout(r, 100))
      }
      return errorData
    }),
    bulkEMSStoresOnboard: flow(function* (storesData) {
      const errorData = []
      for (let i = 0; i < storesData.length; i++) {
        try {
          if (storesData[i].storeCode !== '' && storesData[i].institutionId !== '') {
            const response = yield emsOnboardStores(storesData[i], RootStore.session.getTokens)
            if (response.error) {
              errorData.push({
                status: 'Failed',
                message: response?.error?.message ?? 'Failed',
                code: response?.error?.code ?? '',
              })
            } else {
              errorData.push({ status: 'SUCCESS', message: '', code: '' })
            }
          } else {
            errorData.push({ status: 'Failed', message: 'Invalid Data', code: 'Invalid Data' })
          }
        } catch (e) {
          errorData.push({
            status: 'Failure',
            message: getErrorMessage(e),
            code: (e as any)?.code ?? '',
          })
        }
        yield new Promise((r) => setTimeout(r, 100))
      }
      return errorData
    }),
    bulkInstitutesOnboard: flow(function* (instituteData) {
      const errorData = []
      for (let i = 0; i < instituteData.length; i++) {
        try {
          if (instituteData[i].institutionId !== '' && instituteData[i].name !== '') {
            const response = yield onboardIntitutes(instituteData[i], RootStore.session.getTokens)
            if (response.error) {
              errorData.push({
                status: 'Failed',
                message: response?.error?.message ?? 'Failed',
                code: response?.error?.code ?? '',
              })
            } else {
              errorData.push({ status: 'SUCCESS', message: '', code: '' })
            }
          } else {
            errorData.push({ status: 'Failed', message: 'Invalid Data', code: 'Invalid Data' })
          }
        } catch (e) {
          errorData.push({
            status: 'Failure',
            message: getErrorMessage(e),
            code: (e as any)?.code ?? '',
          })
        }
        yield new Promise((r) => setTimeout(r, 100))
      }
      return errorData
    }),
    bulkEMSInstitutesOnboard: flow(function* (instituteData) {
      const errorData = []
      for (let i = 0; i < instituteData.length; i++) {
        try {
          if (instituteData[i].institutionId !== '' && instituteData[i].name !== '') {
            const response = yield emsOnboardIntitutes(instituteData[i], RootStore.session.getTokens)
            if (response.error) {
              errorData.push({
                status: 'Failed',
                message: response?.error?.message ?? 'Failed',
                code: response?.error?.code ?? '',
              })
            } else {
              errorData.push({ status: 'SUCCESS', message: '', code: '' })
            }
          } else {
            errorData.push({ status: 'Failed', message: 'Invalid Data', code: 'Invalid Data' })
          }
        } catch (e) {
          errorData.push({
            status: 'Failure',
            message: getErrorMessage(e),
            code: (e as any)?.code ?? '',
          })
        }
        yield new Promise((r) => setTimeout(r, 100))
      }
      return errorData
    }),
  }))
  .views((self) => ({
    getDeviceMappings() {
      return self?.devicesList?.map((item) => {
        return {
          id: item?.id,
          mid: item?.mid,
          tid: item?.tid,
          dsn: item?.dsn,
          status: item?.status,
          mapping: item?.link,
          deviceType: item?.deviceType,
          linkedDeviceId: item?.linkedDeviceId,
        }
      })
    },
    getEMSDeviceMappings() {
      return self?.emsDevicesList?.map((item) => {
        return {
          mid: item?.mid,
          tid: item?.tid,
          dsn: item?.dsn,
          status: item?.status,
          mapping: item?.link,
          deviceType: item?.deviceType,
        }
      })
    },
  }))
export const devicesData = Devices.create({
  devicesList: [],
})
